export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/MobileHeroPoster-063382f636070e6044c5b0bcab5e2c41.jpg";